/**
 * Partner Survey Options
 * These options are shown during partner sign-up for research purposes.
 */

export const PARTNER_PROMOTION_CHANNELS = [
  { value: 'social_media', label: 'Social Media (Twitter/X, LinkedIn, etc.)' },
  { value: 'blog_content', label: 'Blog / Content Marketing' },
  { value: 'youtube', label: 'YouTube / Video Content' },
  { value: 'newsletter', label: 'Email Newsletter' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'direct_outreach', label: 'Direct Outreach to Contacts' },
  { value: 'community', label: 'Community / Forum / Discord' },
  { value: 'other', label: 'Other' },
]

export const PARTNER_AUDIENCE_SIZE = [
  { value: 'building', label: "I'm still building my audience" },
  { value: 'small', label: 'Small (1,000 - 5,000 followers/subscribers)' },
  { value: 'medium', label: 'Medium (5,000 - 50,000 followers/subscribers)' },
  { value: 'large', label: 'Large (50,000+ followers/subscribers)' },
]

export const PARTNER_NICHE_OPTIONS = [
  { value: 'product_management', label: 'Product Management' },
  { value: 'startup_founders', label: 'Startup Founders / Entrepreneurs' },
  { value: 'ux_design', label: 'UX / Design' },
  { value: 'software_dev', label: 'Software Development / Tech' },
  { value: 'business_strategy', label: 'Business Strategy / Consulting' },
  { value: 'marketing', label: 'Marketing / Growth' },
  { value: 'innovation', label: 'Innovation / R&D' },
  { value: 'other', label: 'Other' },
]

export const PARTNER_EXPERIENCE_OPTIONS = [
  { value: 'none', label: 'This is my first affiliate program' },
  { value: 'some', label: "I've done a few affiliate promotions before" },
  { value: 'experienced', label: 'I regularly promote affiliate products' },
  { value: 'professional', label: 'Affiliate marketing is a core part of my business' },
]
